import * as React from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';

const BenefitsList = ({ items , className  })=>/*#__PURE__*/ React.createElement("ul", {
        className: classnames('benefits-list', className)
    }, items.map((item)=>/*#__PURE__*/ React.createElement("li", {
            className: "benefits-list__item",
            key: item.title
        }, /*#__PURE__*/ React.createElement(Icon, {
            name: item.iconName,
            className: "benefits-list__icon"
        }), /*#__PURE__*/ React.createElement("p", {
            className: "benefits-list__title"
        }, /*#__PURE__*/ React.createElement("strong", null, item.title)), /*#__PURE__*/ React.createElement("p", {
            className: "benefits-list__subtitle"
        }, item.subtitle))
    ))
;
var BenefitsList$1 = BenefitsList;

export { BenefitsList$1 as default };
//# sourceMappingURL=BenefitsList.js.map
